export const TemporalArray =[
    {id:'S',display:'SI'},
    {id:'N',display:'NO'},
]